<mat-toolbar class="empathy-editor__toolbar">
  @if (surveyEditorService.surveyEditor$().programmerNotes) {
    <div class="empathy-editor__notes">
      <empathy-programmer-notes [programmerNotes]="surveyEditorService.surveyEditor$().programmerNotes"></empathy-programmer-notes>
    </div>
  }

  <div class="empathy-editor__features">
    @if (!translationsOnly) {
      <button mat-button color="primary" [class.active]="activeTab === mainTabs.SurveyEditor" (click)="tabChange.emit(mainTabs.SurveyEditor)">
        <fa-icon [icon]="faPenRuler"></fa-icon>
        <span class="fs__sm fw__500">Survey Editor</span>
      </button>
      <button mat-button color="primary" [class.active]="activeTab === mainTabs.HiddenVariables" (click)="tabChange.emit(mainTabs.HiddenVariables)">
        <fa-icon [icon]="faCube"></fa-icon>
        <span class="fs__sm fw__500">Hidden Variables</span>
      </button>
      <button mat-button color="primary" [class.active]="activeTab === mainTabs.Blocks" (click)="tabChange.emit(mainTabs.Blocks)">
        <fa-icon [icon]="faSlider"></fa-icon>
        <span class="fs__sm fw__500">Blocks</span>
      </button>
      <button mat-button color="primary" [class.active]="activeTab === mainTabs.Sources" (click)="tabChange.emit(mainTabs.Sources)">
        <fa-icon [icon]="faShareNodes"></fa-icon>
        <span class="fs__sm fw__500">Sources</span>
      </button>
    }
    <button mat-button color="primary" [class.active]="activeTab === mainTabs.Translations" (click)="tabChange.emit(mainTabs.Translations)">
      <fa-icon [icon]="faGlobe"></fa-icon>
      <span class="fs__sm fw__500">Translations</span>
    </button>
    @if (!translationsOnly) {
      <button mat-button color="primary" [class.active]="activeTab === mainTabs.FullPreview" (click)="tabChange.emit(mainTabs.FullPreview)">
        <fa-icon [icon]="faEye"></fa-icon>
        <span class="fs__sm fw__500">Preview</span>
      </button>
      <button mat-button [class.active]="activeTab === mainTabs.Settings" (click)="tabChange.emit(mainTabs.Settings)">
        <fa-icon [icon]="faSliders"></fa-icon>
        <span class="fs__sm fw__500">Settings</span>
      </button>
    }
  </div>
</mat-toolbar>
